import React from 'react';
export const downloadSvg = () => {
    return (
        <svg viewBox="0 0 24 24" width="24" height="24" className="">
            <path fill="#565671" d="M18.9 10.3h-4V4.4H9v5.9H5l6.9 6.9 7-6.9zM5.1 19.2v2H19v-2H5.1z"/>
        </svg>
    )
}
